import { render, staticRenderFns } from "./AfiliadosAdmin.vue?vue&type=template&id=1111c1a6&scoped=true&"
import script from "./AfiliadosAdmin.vue?vue&type=script&lang=js&"
export * from "./AfiliadosAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AfiliadosAdmin.vue?vue&type=style&index=0&id=1111c1a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111c1a6",
  null
  
)

export default component.exports